/**
 * Public payment-method values. AMEX and Discover are retained for API compatibility and possible future support;
 * the current Click to Pay enrollment and checkout integrations support only Mastercard and Visa.
 */
export const PaymentMethodEnumsObj = {
  MC: "master",
  VISA: "visa",
  AMEX: "amex",
  DISC: "discover",
  MC_VISA: "master,visa",
  MC_AMEX: "master,amex",
  MC_VISA_AMEX: "master,visa,amex",
  MC_AMEX_VISA: "master,amex,visa",
  MC_VISA_AMEX_DISC: "master,visa,amex,discover",
  MC_VISA_DISC_AMEX: "master,visa,discover,amex",
  MC_AMEX_VISA_DISC: "master,amex,visa,discover",
  MC_AMEX_DISC_VISA: "master,amex,discover,visa",
  MC_DISC_VISA_AMEX: "master,discover,visa,amex",
  MC_DISC_AMEX_VISA: "master,discover,amex,visa",
} as const

export type PaymentMethodEnum = typeof PaymentMethodEnumsObj[keyof typeof PaymentMethodEnumsObj]

/** Card networks supported by the DCF-less First-Time and Returning Add Card flows. */
export type CardEnrollmentPaymentMethodEnum =
  | typeof PaymentMethodEnumsObj.MC
  | typeof PaymentMethodEnumsObj.VISA
  | typeof PaymentMethodEnumsObj.MC_VISA

export type NewUserPaymentMethodEnum = CardEnrollmentPaymentMethodEnum
